import * as types from './mutation-types'

export const getEventBadgeTemplate = ({ commit, dispatch, state }, eventId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/event/${eventId}/badge/template`).then((response) => {
            commit(types.EVENT_BADGE_TEMPLATE, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const generateBadgeFile = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/generate-badge-content/${data.id}`, { params: data }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
